import { chargeReconciliationActions } from './chargeReconciliationActionCreator';

export const initialFilters = {
  client: { id: '' },
  status: null,
  category: null
};

export const initialState = {
  isLoading: false,
  isSuccess: false,
  chargeReconciliationData: [],
  totalElements: 0,
  error: null,
  pageNumber: 0,
  pageSize: 10,
  filters: initialFilters,
  search: '',
  showPagination: true
};

const chargeReconciliationReducer = (state = initialState, action) => {
  switch (action.type) {
    case chargeReconciliationActions.GET_CHARGE_RECONCILIATION_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case chargeReconciliationActions.UPDATE_PAGE_NUMBER: {
      return Object.assign({}, state, { pageNumber: action.payload });
    }

    case chargeReconciliationActions.UPDATE_FILTER: {
      return Object.assign({}, state, {
        filters: Object.assign(state.filters, { [action.key]: action.payload })
      });
    }
    case chargeReconciliationActions.UPDATE_SEARCH: {
      return Object.assign({}, state, { search: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default chargeReconciliationReducer;
